import { Select as NextUISelect, SelectProps as NextUISelectProps } from "@heroui/react";

interface SelectProps extends NextUISelectProps {
}

export const Select = ({ children, ...props }: SelectProps) => {
  return (
    <NextUISelect {...props}>
      {children}
    </NextUISelect>
  );
};